import { gql } from "@apollo/client";

export const GET_USER_ACTIVITY = gql`
  query getUserActivities(
    $filter: UserFilterInputType
    $activityfilter: FieldFilterInputType
    $uniqueResult: Boolean
    $pagination: PaginationInputType
  ) {
    getUserFlows(filter: $filter, activityfilter: $activityfilter, uniqueResult:$uniqueResult, pagination: $pagination) {
      userActivities {
        firstName
        lastName
        username
        regionCity
        regionState
        regionCountry
        type
        parameters
        createdAt
      }
      total
    }
  }
`;

export const GET_PARAMETER_AUTOCOMPLETE = gql`
  query parameterAutocomplete($filter: String) {
    parameterAutocomplete(filter: $filter)
  }
`;